import * as XLSX from 'xlsx';

function normalizarEncabezado(texto) {
  return String(texto)
    .normalize('NFD')
    .replace(/[̀-ͯ]/g, '') // quita acentos
    .trim()
    .toUpperCase();
}

function buscarValor(fila, ...nombresPosibles) {
  const buscados = nombresPosibles.map(normalizarEncabezado);
  for (const clave of Object.keys(fila)) {
    if (buscados.includes(normalizarEncabezado(clave))) {
      return fila[clave];
    }
  }
  return undefined;
}

// Normaliza a "HH:MM:00" (formato TIME de MySQL), acepte texto "HH:MM" o el
// número de Excel (fracción de día).
function normalizarHora(valor) {
  if (valor === null || valor === undefined || valor === '') return null;

  if (typeof valor === 'number') {
    const minutosTotales = Math.round(valor * 24 * 60);
    const h = Math.floor(minutosTotales / 60) % 24;
    const m = minutosTotales % 60;
    return `${String(h).padStart(2, '0')}:${String(m).padStart(2, '0')}:00`;
  }

  const texto = String(valor).trim();
  const match = texto.match(/^(\d{1,2}):(\d{2})/);
  if (!match) return null;
  return `${match[1].padStart(2, '0')}:${match[2]}:00`;
}

const CATEGORIAS_VALIDAS = ['Cultura', 'Deporte'];

export async function parseArchivoMaterias(file) {
  const buffer = await file.arrayBuffer();
  const workbook = XLSX.read(buffer, { type: 'array' });
  const primeraHoja = workbook.Sheets[workbook.SheetNames[0]];
  const filasCrudas = XLSX.utils.sheet_to_json(primeraHoja, { defval: '' });

  const filas = filasCrudas.map((filaCruda, indice) => ({
    fila: indice + 2, // +2: encabezado + índice base 1, para mensajes de error legibles
    ID: buscarValor(filaCruda, 'ID'),
    CODE: buscarValor(filaCruda, 'CODE') ?? '',
    NAME: buscarValor(filaCruda, 'NAME'),
    GROUP: buscarValor(filaCruda, 'GROUP') ?? '',
    MON: buscarValor(filaCruda, 'MON') || '',
    TUE: buscarValor(filaCruda, 'TUE') || '',
    WED: buscarValor(filaCruda, 'WED') || '',
    THU: buscarValor(filaCruda, 'THU') || '',
    FRI: buscarValor(filaCruda, 'FRI') || '',
    BEGIN: normalizarHora(buscarValor(filaCruda, 'BEGIN')),
    END: normalizarHora(buscarValor(filaCruda, 'END')),
    CATEGORY: buscarValor(filaCruda, 'CATEGORY'),
    CAPACITY: buscarValor(filaCruda, 'CAPACITY'),
  }));

  const errores = [];
  filas.forEach((f) => {
    if (!f.ID) errores.push(`Fila ${f.fila}: falta ID`);
    if (!f.NAME) errores.push(`Fila ${f.fila}: falta NAME`);
    if (!f.BEGIN || !f.END) errores.push(`Fila ${f.fila}: falta BEGIN o END (hora inválida)`);
    if (!f.CAPACITY) errores.push(`Fila ${f.fila}: falta CAPACITY`);
    if (!f.CATEGORY) {
      errores.push(`Fila ${f.fila}: falta CATEGORY`);
    } else if (!CATEGORIAS_VALIDAS.includes(String(f.CATEGORY).trim())) {
      errores.push(`Fila ${f.fila}: CATEGORY "${f.CATEGORY}" no es "Cultura" ni "Deporte"`);
    }
  });

  return { filas, errores };
}
